import React, { useContext, useEffect, useState } from 'react';
import { IconButton } from '@one-thd/sui-atomic-components';
import { Printer } from '@one-thd/sui-icons';
import { useStore } from '@thd-nucleus/experience-context';
import { ProductListContext } from '../ProductListContext';

export const PrintButton = () => {
  const {
    list,
    isSharedList
  } = useContext(ProductListContext);

  const [printUrl, setPrintUrl] = useState('');
  const { id } = list;
  const store = useStore({ varnish: true });
  const { storeId } = store;
  let baseUrl = '';

  if (typeof window !== 'undefined') {
    baseUrl = window.origin;
  }

  useEffect(() => {
    if (isSharedList) {
      const newPrintUrl = `${baseUrl}/customer/list/v1/sharelist/pdf/${id}`;
      setPrintUrl(newPrintUrl);
    } else {
      const newPrintUrl = `${baseUrl}/customer/list/v1/listdetailsPdf/`
      + `${id}/storeId/${storeId}/ownerName/self`;
      setPrintUrl(newPrintUrl);
    }
  }, [storeId, isSharedList]);

  const handlePrintClick = () => {
    LIFE_CYCLE_EVENT_BUS.trigger('product-list.print-list', {});
  };

  return (
    <IconButton
      iconSize="regular"
      icon={Printer}
      onClick={handlePrintClick}
      alt="Print"
      aria-label="Print"
      href={printUrl}
      target="_blank"
      component="a"
    />
  );
};

PrintButton.displayName = 'ProductListPrint';
